"use strict";
/**
 * The shops module provides access to the shops (organization unit type) data from the EVA back-end
 * @preferred
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
/**
 * Provides access to a content page available in EVA
 */
var Shop = /** @class */ (function (_super) {
    __extends(Shop, _super);
    function Shop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetches the page content
     * @return {Promise<IEVAServiceResponse<EVA.Core.Services.GetOrganizationUnit, EVA.Core.Services.GetOrganizationUnitResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    Shop.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            OrganizationUnitID: this.getId()
        };
        return _super.prototype.fetch.call(this, "GetOrganizationUnit", requestData);
    };
    return Shop;
}(base_1.FetchableItem));
exports.Shop = Shop;
/**
 * Provides access to a list of shops available in EVA
 */
var ShopList = /** @class */ (function (_super) {
    __extends(ShopList, _super);
    function ShopList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Core.Services.ListOrganizationUnitsResponseOrganizationUnit, EVA.Core.Services.ListOrganizationUnits, EVA.Core.Services.ListOrganizationUnitsResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    ShopList.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            PageConfig: this.getPageConfiguration(),
            OrganizationUnitTypes: 1,
            IncludeParentApplications: undefined,
            __response: undefined
        };
        return _super.prototype.fetch.call(this, "ListOrganizationUnits", requestData);
    };
    return ShopList;
}(base_1.FetchablePagedList));
exports.ShopList = ShopList;
/**
 * Provides access to a list of shops available in EVA
 */
var ShopProximityList = /** @class */ (function (_super) {
    __extends(ShopProximityList, _super);
    function ShopProximityList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Optional location to use for the shop list (proximity search)
         * @type {string}
         */
        _this.location = {
            lat: null,
            lng: null
        };
        return _this;
    }
    /**
     * Changes to list of shops returned to those in the closest proximity of the given location
     * @param  {number} lat The locations latitude
     * @param  {number} lng The locations longitude
     * @return {object}     The chosen location
     */
    ShopProximityList.prototype.setLocation = function (lat, lng) {
        this.location.lat = lat;
        this.location.lng = lng;
        return this.location;
    };
    /**
     * Returns the currently chosen location to use for a proximity based shop list
     * @return {object} The currently chosen location
     */
    ShopProximityList.prototype.getLocation = function () {
        return this.location;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Core.OrganizationUnitDto, EVA.Core.Services.ListOrganizationUnitByProximity, EVA.Core.Services.ListOrganizationUnitByProximityResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    ShopProximityList.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            PageConfig: this.getPageConfiguration(),
            Latitude: this.location.lat,
            Longitude: this.location.lng
        };
        return _super.prototype.fetch.call(this, "ListOrganizationUnitByProximity", requestData);
    };
    return ShopProximityList;
}(base_1.FetchablePagedList));
exports.ShopProximityList = ShopProximityList;
